import { Button, HeaderSection, Icon, IconType } from '@lmc/ui-kit'
import { ProTag } from 'components/ProTag'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
  testId?: string
}

export function CarerSkillsHeaderSection({
  handleView,
  handleToggleModal,
  testId
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <HeaderSection
      backLink
      onClick={handleView}
      title={
        <div
          style={styles.flex}
          data-testid={testId ? `${testId}-title` : undefined}
        >
          {t(`skillsAndNeeds.skillsAndTrainings`)}
          <ProTag />
        </div>
      }
      iconColor="#EFEEFF"
      iconContent={
        <Icon customIcon={IconType.LogoPurple} style={styles.logoIcon} />
      }
      rightChildren={
        <Button
          icon={<Icon name="PlusOutlined" />}
          variant="primary"
          onClick={handleToggleModal}
          data-testid={testId ? `${testId}-add-skill-button` : undefined}
        >
          {t(`skillsAndNeeds.assignNewSkillButton`)}
        </Button>
      }
      testId={testId}
    />
  )
}

const styles = {
  logoIcon: {
    width: 26,
    height: 26
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  }
}

export default CarerSkillsHeaderSection
